import { Heart, Search, HandHeart, Share2, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

const steps = [
  { icon: Search, title: "Znajdź", desc: "schronisko blisko siebie", color: "#4E8A6E" },
  { icon: Heart, title: "Sprawdź", desc: "aktualne potrzeby", color: "#3D7A5E" },
  { icon: HandHeart, title: "Pomóż", desc: "darami lub wolontariatem", color: "#3D6B56" },
  { icon: Share2, title: "Udostępnij", desc: "i zaangażuj innych 💚", color: "#5DADA0" },
];

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost3Cards = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "100px",
        }}
      >
        {/* Header */}
        <h1
          style={{
            fontSize: "72px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 56px 0",
            textAlign: "center",
            lineHeight: 1.1,
          }}
        >
          Chcesz pomóc?<br />To proste! 👇
        </h1>

        {/* Stacked cards */}
        <div
          style={{
            position: "relative",
            width: "700px",
            height: "480px",
          }}
        >
          {steps.map((s, i) => (
            <div
              key={i}
              style={{
                position: "absolute",
                left: `${i * 24}px`,
                top: `${i * 100}px`,
                width: `${700 - i * 48}px`,
                background: `linear-gradient(135deg, ${s.color} 0%, ${s.color}DD 100%)`,
                borderRadius: "24px",
                padding: "28px 36px",
                display: "flex",
                alignItems: "center",
                gap: "24px",
                boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                zIndex: 4 - i,
              }}
            >
              {/* Number */}
              <div
                style={{
                  width: "64px",
                  height: "64px",
                  background: "rgba(255,255,255,0.25)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <span style={{ fontSize: "32px", fontWeight: 800, color: "#FFFFFF" }}>
                  {i + 1}
                </span>
              </div>

              {/* Icon */}
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  background: "rgba(255,255,255,0.2)",
                  borderRadius: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <s.icon style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
              </div>

              {/* Text */}
              <div style={{ textAlign: "left" }}>
                <h3 style={{ fontSize: "32px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                  {s.title}
                </h3>
                <p style={{ fontSize: "20px", color: "rgba(255,255,255,0.9)", margin: "4px 0 0", fontWeight: 500 }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Logo */}
        <div
          style={{
            marginTop: "56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

